import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { TokenService } from './token.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class BasicAuthHtppInterceptorServiceService implements HttpInterceptor {
  constructor(private tokenService: TokenService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      headers: this.tokenService.createTokenHeader()
    });
    return next.handle(req).pipe(tap(event => event, event => this.handleError(event)));
  }

  private handleError(event: HttpEvent<any>): HttpEvent<any> {
    if (event instanceof HttpErrorResponse) {
      const error = <HttpErrorResponse>event;
      console.log(`failed: ${error.message}`);
    }
    return event;
  }
}
